import { render, staticRenderFns } from "./wizard-body.vue?vue&type=template&id=661833fc&scoped=true&"
import script from "./wizard-body.vue?vue&type=script&lang=ts&"
export * from "./wizard-body.vue?vue&type=script&lang=ts&"
import style0 from "./wizard-body.vue?vue&type=style&index=0&id=661833fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661833fc",
  null
  
)

export default component.exports